import * as Sentry from "@sentry/react";
import { none } from "ramda";
import React, { useState, useEffect } from "react";
import { Container, Alert } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import FlashMessage from "../components/FlashMessage.jsx";

const AppLayout = ({ children, Header }) => {
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleError = (error, info) => {
      setError(error);
      if (typeof Sentry !== "undefined") {
        Sentry.withScope((scope) => {
          scope.setExtras(info);
          Sentry.captureException(error);
        });
      }
    };

    window.addEventListener("error", handleError);
    return () => window.removeEventListener("error", handleError);
  }, []);

  // Hide header on certain routes
  const showHeader = none(
    (it) => location.pathname.startsWith(it),
    [
      "/vehicle/status/",
      "/vehicle-wash-status/",
      "/malfunctions/open/",
      "/malfunctions/open-internal/",
      "/malfunctions/open-route/",
    ],
  );

  if (error) {
    return (
      <Container className="mt-3">
        <Alert variant="danger">
          <h4>Fout</h4>
          Er is een fout opgetreden in de applicatie.
        </Alert>
      </Container>
    );
  }

  return (
    <>
      <FlashMessage />
      {showHeader && <Header />}
      <Container fluid>{children}</Container>
    </>
  );
};

export default AppLayout;
